import script from "./RequiredStaffImportText.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequiredStaffImportText.vue?vue&type=script&setup=true&lang=ts"

import "./RequiredStaffImportText.vue?vue&type=style&index=0&id=8d10f3f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d10f3f2"]])

export default __exports__